"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodePostRating = decodePostRating;
exports.formatPostRating = formatPostRating;
exports.isPostKarmaVotingEnabled = isPostKarmaVotingEnabled;
function decodePostRating(raw) {
    const n = typeof raw === 'number' ? raw : Number(raw) || 0;
    return {
        raw: n,
        value: n >> 3,
        visible: (n & 1) !== 0,
        userVote: (n & 2) !== 0 ? ((n & 4) !== 0 ? 1 : -1) : undefined,
    };
}
/** Текст для UI: +2, 0, -1 */
function formatPostRating(value) {
    if (value > 0)
        return `+${value}`;
    return String(value);
}
/** Можно ли поставить оценку посту (как KarmaEnabled в Android Post.cs). */
function isPostKarmaVotingEnabled(post) {
    const raw = post.ratingRaw ?? 0;
    const visible = post.ratingVisible ?? (raw & 1) !== 0;
    if (!visible)
        return false;
    if (post.userPostVote !== undefined)
        return false;
    return true;
}
